import React from "react";
import PropTypes from "prop-types";
import { Popover } from "antd";
//import jMoment from "moment-jalaali";
import jMoment from "components/classes/Jmomen";
import MaterialIcon from "../../MaterialIcon";

@autobind
/**
 *
 */
export default class Day extends React.PureComponent {
  static propTypes = {
    date: PropTypes.string,
    onHover: PropTypes.func,
    onMouseDown: PropTypes.func,
    onMouseUp: PropTypes.func,
    events: PropTypes.arrayOf(
      PropTypes.shape({
        color: PropTypes.string,
        content: PropTypes.string,
      }),
    ),
    status: PropTypes.shape({
      color: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
    }),
    selected: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.string,
    ]),
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    date: "",
    onHover: () => { },
    onMouseDown: () => { },
    onMouseUp: () => { },
    events: [],
    selected: false,
    disabled: false,
  };

  /**
   *
   * @private
   */
  _onMouseEnter() {
    const { onHover, date, disabled } = this.props;

    if (!app._.isEmpty(date) && !disabled) onHover(date);
  }

  /**
   *
   * @private
   */
  _onMouseDown() {
    const { onMouseDown, date, disabled } = this.props;

    if (!app._.isEmpty(date) && !disabled) onMouseDown(date);
  }

  /**
   *
   * @private
   */
  _onMouseUp() {
    const { onMouseUp, date, disabled } = this.props;

    if (!app._.isEmpty(date) && !disabled) onMouseUp(date);
  }

  /**
   *
   * @return {XML}
   * @private
   */
  _renderTitle() {
    const { status, date } = this.props;

    return (
      <div key={0}>
        {
          status &&
          <p className="left" style={{ color: status.color }}>{status.title}</p>
        }
        <p className="right">{date}</p>
      </div>
    );
  }

  /**
   *
   * @return {XML[]}
   * @private
   */
  _renderContent() {
    const { status, events } = this.props;
    const _events = [];

    if ((status && status.description) || (events && events[0] && events[0].shiftName )) {
      _events.push(
        <div key={0} style={{display:'flex', flexDirection:'column'}}>
          {events && events[0] && events[0].shiftName &&
          <div style={{display: 'flex' , alignItems: 'center', width: '100%'}}>
            <p>{app.translate('نام شیفت : ')}</p>
            <p>{events[0].shiftName}</p>
            </div>

          }
          {status && status.description &&
          <p
              style={{
                width: "100%",
                textAlign: "center",
                borderBottom: events.length > 0 && "1px rgba(158, 158, 158, .5) solid",
                marginBottom: 4,
              }}
          >
            {status.description}

          </p>
          }
        </div>,
      );
    }

    events.forEach((event, index) => {
      if (event.workingHourIds) {
        event.workingHourIds.map((whId, index2) => {
          _events.push(<div key={"wh"+(index + 1)*10+ index2} style={whId.style}>
                <MaterialIcon name="mdi mdi-clock false" style={{color: whId.color}}/>
                <p>{whId.content}</p>
              </div>
          );
        })
      }
      if ( event.settingIds) {
        event.settingIds.map((settingId, index3) => {
          _events.push(<div key={'setting'+(index + 1)*11 + index3} style={settingId.style}>
                <MaterialIcon name="mdi mdi-settings false   " style={{color: settingId.color}}/>
                <p>{settingId.content}</p>
              </div>
          );
        })
      }
       if ( event.policyIds ) {
        event.policyIds.map((policyId, index3) => {
          if(policyId) {
            _events.push(<div key={"pc" + (index + 1) * 12 + index3} style={policyId.style}>
                  <MaterialIcon name="mdi mdi-scale-balance false" style={{color: policyId.color}}/>
                  <p>{policyId.content}</p>
                </div>
            );
          }
        })
      }

      if (event.finalWorkingHoursIds) {
        event.finalWorkingHoursIds.map((whId, index2) => {
          if(whId) {
            _events.push(<div key={"fn_wh" + (index + 1) * 10 + index2} style={Object.assign({} , whId.style , {borderTop: index2 === 0 ? '1px solid gray' : ''})}>
                  <MaterialIcon name="mdi mdi-clock false" style={{color: whId.color}}/>
                  <p>{whId.content}</p>
                </div>
            );
          }
        })
      }
      if(event.foodId) {
        _events.push(<div key={index + 1} style={event.style}>
              <MaterialIcon name="checkbox-blank-circle" style={{color: event.color}}/>
              <p>{event.content}</p>
            </div>
        );
      }
    })
    return _events;
  }

  /**
   *
   * @return {String}
   * @private
   */
  _renderClassNames() {
    const { date, disabled, selected } = this.props;
    let classNames = "day";

    if (date.equals(jMoment().format("jYYYY-jMM-jDD"))) {
      classNames = `${classNames} today`;
    }

    if (app._.isEmpty(date)) {
      classNames = `${classNames} empty`;
    } else if (disabled) {
      classNames = `${classNames} disabled`;
    } else {
      switch (selected) {
        case true:
          classNames = `${classNames} selected`;
          break;
        case "range":
          classNames = `${classNames} range`;
          break;
        case "start":
          classNames = `${classNames} range start`;
          break;
        case "end":
          classNames = `${classNames} range end`;
          break;
        case "selecting":
          classNames = `${classNames} range selecting`;
          break;
      }
    }

    return classNames;
  }

  /**
   * @return {Object}
   * @private
   */
  _renderEventShadow(events){
    if (events.length === 1) {
      return `${events[0].color} 0 -4px 0 0 inset`;
    } else if (events.length <= 3) {

      let _boxShadows = [];

      events.map((event, index) => {
        _boxShadows.push(
            `${event.color} 0 -${(index + 1) * 2}px 0 0 inset`,
        );
      });

      return  _boxShadows.join(', ');
    } else {
      const _boxShadows = [];

      for (let _index = 0; _index < 3; _index++) {
        _boxShadows.push(`${events[_index].color} 0 -${(_index + 1) * 2}px 0 0 inset`);
      }

      return  _boxShadows.join(", ");
    }
  }

  /**
   * @return {Object}
   * @private
   */
  _renderSettingsShadow(events){
    if (events.length === 1) {
      return `${events[0].color} 0 4px 0 0 inset`;
    } else if (events.length <= 3) {

      let _boxShadows = [];

      events.map((event, index) => {
        _boxShadows.push(
            `${event.color} 0 ${(index + 1) * 2}px 0 0 inset`,
        );
      });

      return  _boxShadows.join(', ');
    } else {
      const _boxShadows = [];

      for (let _index = 0; _index < 3; _index++) {
        _boxShadows.push(`${events[_index].color} 0 ${(_index + 1) * 2}px 0 0 inset`);
      }

      return  _boxShadows.join(", ");
    }
  }

  /**
   * @return {Object}
   * @private
   */
  _renderPolicyShadow(events){
    if (events.length === 1) {
      return `${events[0].color} 4px 0 0 0 inset`;
    } else if (events.length <= 3) {

      let _boxShadows = [];

      events.map((event, index) => {
        _boxShadows.push(
            `${event.color}  ${(index + 1) * 2}px 0 0 0 inset`,
        );
      });

      return  _boxShadows.join(', ');
    } else {
      const _boxShadows = [];

      for (let _index = 0; _index < 3; _index++) {
        _boxShadows.push(`${events[_index].color} ${(_index + 1) * 2}px 0 0 0 inset`);
      }

      return  _boxShadows.join(", ");
    }
  }

  /**
   *
   * @return {Object}
   * @private
   */
  _renderStyle() {
    const { status, events } = this.props;
    const style = {};

    if (status) style.color = status.color;

    if (!app._.isEmpty(events)) {
      let _boxShadow = "";
      if(events[0].workingHourIds ){
        _boxShadow = this._renderEventShadow(events[0].workingHourIds);
      }
      if(events[0].settingIds ){
        _boxShadow += ", "+this._renderSettingsShadow(events[0].settingIds);
      }
      if(events[0].policyIds ){
        _boxShadow += ", "+this._renderPolicyShadow(events[0].policyIds);
      }
      else {
        _boxShadow = this._renderEventShadow(events);
      }
      style.boxShadow = _boxShadow;
    }

    return style;
  }

  /**
   *
   * @return {Object}
   * @private
   */
  renderIcons = ()=>{
    const { events } = this.props;
    let _workingHourEventIcons = [];
    let settingEventIcons = [];
    let policyEventIcons = [];
    let _events = [];
    events.forEach((event, index) => {
      if (event.workingHourIds) {
        event.workingHourIds.map((whId, index2) => {
          _workingHourEventIcons.push(<div key={"wh"+(index + 1)*10+ index2} style={{ background: whId.color, height: '2px'}}>
                {/*<MaterialIcon name="mdi mdi-settings false   " style={{color: whId.color}}/>*/}
              </div>
          );
        })
      }

      if ( event.settingIds) {
        event.settingIds.map((settingId, index3) => {
          settingEventIcons.push(<div key={'setting'+(index + 1)*11 + index3} style={{ background: settingId.color, height: '2px'}}>
                {/*<MaterialIcon name="mdi mdi-clock false" style={{color: settingId.color}}/>*/}
              </div>
          );
        })
      }

      if ( event.policyIds ) {
        event.policyIds.map((policyId, index3) => {
          if(policyId) {
            policyEventIcons.push(<div key={"pc" + (index + 1) * 12 + index3}
                                       style={{background: policyId.color, height: '2px'}}>
                  {/*<MaterialIcon name="mdi mdi-scale-balance false" style={{color: policyId.color}}/>*/}
                </div>
            );
          }
        })
      }
      if(event.foodId) {
        _events.push(<div key={index + 1} style={event.style}>
              <MaterialIcon name="checkbox-blank-circle" style={{color: event.color}}/>
            </div>
        );
      }
    })

    return events ?
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'row' ,
          position: 'absolute',
          bottom: 0,
          height: '30%',
          width: '100%',

        }}
        >
          { _workingHourEventIcons? <div style={{display: 'flex', justifyContent: 'right', flexDirection: 'column',width: '30%'}}> {_workingHourEventIcons} </div> : <div/>}
          { policyEventIcons? <div style={{display: 'flex', justifyContent: 'right', flexDirection: 'column',width: '30%'}}> {policyEventIcons} </div> : <div/>}
          { settingEventIcons? <div style={{display: 'flex', justifyContent: 'right', flexDirection: 'column',width: '30%'}}> {settingEventIcons} </div> : <div/>}
          { _events? <div style={{display: 'flex', justifyContent: 'right', flexDirection: 'row'}}> {_events} </div> : ""}
    </div>
        : "";

    // return <MaterialIcon name="mdi mdi-scale-balance false" style={{color: policyId.color}}/>
  }

  renderBorder = (type )=>{
    switch (type) {
      case 'shift':
        return 'lightgreen';
      case 'mask':
        return 'purple';
      case 'replacement':
        return 'red';
      case 'exchange':
        return 'blue';
      default:
        return 'black';
    }
  };

  /**
   *
   * @return {XML}
   */
  render() {
    const { date, events, status } = this.props;

    const _day = (
      <td
        className={this._renderClassNames()}
        onMouseEnter={this._onMouseEnter}
        onMouseDown={this._onMouseDown}
        onMouseUp={this._onMouseUp}
        style={ { border: `2px solid ${events  && events[0] && events[0].type  && this.renderBorder(events[0].type)  }`, borderRadius: '8px' , color: status ? status.color: 'undefined'}}
      >
        {app._.isEmpty(date) ? date : date.substr(8, 2) * 1}
        {this.renderIcons()}
      </td>
    );

    return !app._.isEmpty(events) || status ? (
      <Popover
        content={this._renderContent()}
        title={this._renderTitle()}
        overlayClassName="calendar-events"
        mouseEnterDelay={1}
        arrowPointAtCenter
      >
        {_day}
      </Popover>
    ) : _day;
  }
}
